import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { GetStakeableDataByIdQuery } from "../../../../api/graphql/staking/generated/staking.stakeable-info-by-id.service.graphql-gen";
import { Stakeable } from "@modules/staking/domain/entities/stakeable.model";
import { Tradable } from "@models/interfaces/tradable";
import { StakeableAvailability } from "@modules/staking/domain/entities/stakable-availability.model";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { StakingType } from "@gql/staking";

export class StakingAdpAdapter extends BaseAdapter<GetStakeableDataByIdQuery, Stakeable> {
	public constructor(private readonly tradableListService: TradableListService) {
		super();
	}

	public adapt(stakeableInfo: GetStakeableDataByIdQuery): Stakeable {
		const stakeable = this.parseStakeableFromInfo(stakeableInfo);

		const balance = stakeableInfo.balances.find((balance) => balance.asset.assetId === stakeable.id);
		stakeable.stakedAmount = balance?.stakedAmount.value || "";
		const rewards = balance?.rewardsAmount;
		if (rewards) {
			["totalCurrent", "totalLastMonth"].forEach((field) => {
				stakeable.rewardsAmount[field] = {
					fiat: rewards[field].fiat.value,
					asset: rewards[field].asset.value
				};
			});
		}
		return stakeable;
	}

	private parseStakeableFromInfo(stakeableInfo: GetStakeableDataByIdQuery): Stakeable {
		const item = stakeableInfo.assetConfig.assets[0];
		const asset: Tradable = this.tradableListService.getItemById(item.assetId);
		return {
			id: item.assetId,
			availability: item.availability as StakeableAvailability,
			yearlyInterest: item.yearlyInterest,
			name: asset?.getName() || "",
			symbol: asset?.getSymbol() || "",
			stakedAmount: "",
			rewardIntervals: item.rewardIntervalInDays,
			nextReward: item.nextReward,
			rewardsAmount: {
				totalCurrent: {
					fiat: "0",
					asset: "0"
				},
				totalLastMonth: {
					fiat: "0",
					asset: "0"
				}
			},
			minStakingAmount: item.minStakingAmount?.value,
			isLocked: item.stakingType === StakingType.Locked,
			unboundPeriod: item.unboundPeriod,
			autoStakingEnabled: item.isAutoStakingEnabled,
			stakingMode: item.stakingMode
		};
	}
}
